export default "__VITE_ASSET__CaSH804X__"